import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoAreaMultiselectComponent } from './novo-area-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoAreaMultiselectComponent],
  exports: [NovoAreaMultiselectComponent]
})
export class NovoAreaMultiselectModule {}
